module.exports = __webpack_public_path__ + "img/card-profile2-square.788e3d36.jpg";